import axios from 'axios';

export const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const withAuth = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('commpro_token') || ''}` },
});

export function apiError(e, fallback = 'Something went wrong. Please try again.') {
    const detail = e?.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) return detail.map((d) => d?.msg || '').filter(Boolean).join(' ');
    return fallback;
}
